import BarChart2 from 'assets/icons/BarChart2';
import COLOR from 'constants/color';
import { LOG_SUMMARY_OPTION } from 'constants/general';
import { t } from 'services/i18n.service';

interface LogTypeProps {
  logSummaryType: string;
  onLogSummaryTypeChange: (value: string) => void;
  choiceId?: string;
}

const LogType: React.FC<LogTypeProps> = ({
  logSummaryType,
  onLogSummaryTypeChange,
  choiceId
}) => {
  return (
    <div className='flex flex-col ~gap-3/4'>
      <div className='flex flex-col gap-0.5'>
        <div className='flex items-center ~gap-1/2'>
          <BarChart2 className='~w-3/4 ~h-3/4' fill={COLOR.PRIMARY.LIGHT_900} />
          <h3 className='~text-xs/sm font-normal'>
            {t('tabs_revamp.log_data_tab.log_type')}
          </h3>
        </div>
        <p className='~text-[0.625rem]/xs text-gray-600 dark:text-gray-400 '>
          {t('tabs_revamp.log_data_tab.log_type_description')}
        </p>
      </div>

      <div className='flex items-center ~gap-4/6'>
        <label className='flex items-center ~gap-2/3 cursor-pointer'>
          <input
            type='radio'
            name={`logSummaryType-${choiceId || 'default'}`}
            value={LOG_SUMMARY_OPTION.SUMMATION}
            checked={logSummaryType === LOG_SUMMARY_OPTION.SUMMATION}
            onChange={(e) => onLogSummaryTypeChange(e.target.value)}
            className='w-4 h-4 text-primary-900 focus:ring-primary-500 focus:ring-2 border-gray-300 dark:border-gray-600'
          />
          <span className='~text-xs/sm'>
            {t('tabs_revamp.log_data_tab.total')}
          </span>
        </label>
        <label className='flex items-center ~gap-2/3 cursor-pointer'>
          <input
            type='radio'
            name={`logSummaryType-${choiceId || 'default'}`}
            value={LOG_SUMMARY_OPTION.AVERAGE}
            checked={logSummaryType === LOG_SUMMARY_OPTION.AVERAGE}
            onChange={(e) => onLogSummaryTypeChange(e.target.value)}
            className='w-4 h-4 text-primary-900 focus:ring-primary-500 focus:ring-2 border-gray-300 dark:border-gray-600'
          />
          <span className='~text-xs/sm'>
            {t('tabs_revamp.log_data_tab.average')}
          </span>
        </label>
      </div>
    </div>
  );
};

export default LogType;
